import React from "react";
import {
  Table,
  TableBody,
  TableBodyProps,
  TableCell,
  TableCellProps,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableHeadProps,
  TableProps,
  TableRow,
  TableRowProps,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

type WcTableWrapperProps = TableProps & {
  tableHeadRows: React.JSX.Element;
  tableBodyRows: React.JSX.Element[];
  tableContainerMaxHeight?: string | number;
};

export const WcTableWrapper = ({ tableHeadRows, tableBodyRows, tableContainerMaxHeight = undefined, ...props }: WcTableWrapperProps) => (
  <TableContainer sx={{ maxHeight: tableContainerMaxHeight }}>
    <Table {...props}>
      <TableHead>{tableHeadRows}</TableHead>
      <TableBody>{tableBodyRows}</TableBody>
    </Table>
  </TableContainer>
);

export default WcTableWrapper;

export type WcTableProps = TableProps;

export const WcTable = ({ children, ...props }: WcTableProps) => <Table {...props}>{children}</Table>;

export type WcTableRowProps = TableRowProps;

export const WcTableRow = ({ children, ...props }: WcTableRowProps) => <TableRow {...props}>{children}</TableRow>;

export type WcTableCellProps = TableCellProps;

export const WcTableCell = ({ children, ...props }: WcTableCellProps) => <TableCell {...props}>{children}</TableCell>;

export type WcTableHeadProps = TableHeadProps;

export const WcTableHead = ({ children, ...props }: WcTableHeadProps) => <TableHead {...props}>{children}</TableHead>;

export type WcTableBodyProps = TableBodyProps;

export const WcTableBody = ({ children, ...props }: WcTableBodyProps) => <TableBody {...props}>{children}</TableBody>;

export type WcTableContainerProps = TableContainerProps;

export const WcTableContainer = ({ children, ...props }: WcTableContainerProps) => <TableContainer {...props}>{children}</TableContainer>;

export const useWcTableCellClasses = () => tableCellClasses;
